module.exports = __webpack_public_path__ + "static/img/5826d389099bf3cedd3823cf9316b7c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/usb_white.png
// module id = +mR2
// module chunks = 1